import React, { Component } from "react";
import { Container, Spinner, Row, Col, CardGroup, Card, CardBody, CardFooter, Form, UncontrolledTooltip, Button, InputGroup, Jumbotron, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { QRCode } from "react-qr-svg";
import $ from "jquery";
import { loginFunction, getLoginSettings, get_two_factor, getSecret, setSecret } from "../../../actions/actionLogin";
import { getSignOnURL } from "../../../actions/actionSaml";
import { required, renderField, secret } from "../../../utils/formValidations.js";
import "../../../../assets/style/style.css";
import LoadingSpinner from "../../../components/LoadingSpinner/index";
import kasmlogo from "../../../../assets/images/kasmlogo.svg"

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: true,
            loginBoxClass: "",
            loginClicked: false,
            authModal: false,
            setModal: false,
            brandingSet: false,
            loginData: {}
        };
        this.handleLogin = this.handleLogin.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.loginError = this.loginError.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggle2 = this.toggle2.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleSetSecret = this.handleSetSecret.bind(this);
        this.singleSignOn = this.singleSignOn.bind(this);
        this.handleSSOSuccess = this.handleSSOSuccess.bind(this);
        this.handleSSOError = this.handleSSOError.bind(this);
    }

    handleLogin({ username, password }) {

        let login_data = {
            "username": username.trim().toLowerCase(),
            "password": password
        };
        this.setState({loginBoxClass: "", error:true, loginClicked: true, loginData: login_data});
        this.props.loginFunc(login_data).
            then(() => this.completeLogin(login_data)).
            catch(() => this.loginError());
    }

    loginError() {
        if (this.state.error) {
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            NotificationManager.error(this.props.loginError,"Login Failed", 5000);
        }
    }

    completeLogin(login_data) {
        const { loginError } = this.props;
        if (this.props.has2fa && !loginError) {
            if (!this.props.new_two_factor) {
                //first time setup of two factor
                this.props.setSecret(login_data).then(() => this.setState({secret : this.props.generated_secret, setModal: true}));
            } else
                //two factor one time password check
                this.setState({authModal: true})
        //Normal Login
        } else {
            if (loginError) {
                this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
                NotificationManager.error(loginError,"Login Failed", 5000);
            } else {
                if (this.props.location.state === "/" || this.props.location.state === undefined || this.props.location.state.from.pathname.indexOf("logout") > -1) {
                    if (this.props.auto_login_kasm) {
                        window.location.href = "/#/go";
                    } else {
                        window.location.href = "/#/";
                    }
                } else {
                    window.location.href = "/#" + this.props.location.state.from.pathname + this.props.location.state.from.search;
                }
            }
        }
    }

    handleAuth({ authCode }) {
        //Do authorization in backend
        let login_data = this.state.loginData;
        login_data.code = authCode;
        this.props.get_two_factor(login_data).
            then(() => this.handleSuccess()).
            catch(() => this.handleError());
    }

    handleSuccess() {
        const {twoFactorErrorMessage} = this.props;
        if(twoFactorErrorMessage){
            NotificationManager.error(twoFactorErrorMessage,"Two Factor Authentication Failed", 3000);
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            this.toggle();
        //Two Factor Login
        } else {
            if (this.props.location.state === "/" || this.props.location.state === undefined || this.props.location.state.from.pathname.indexOf("logout") > -1) {
                if (this.props.auto_login_kasm) {
                    window.location.href = "/#/go";
                } else {
                    window.location.href = "/#/";
                }
            } else {
                window.location.href = "/#" + this.props.location.state.from.pathname + this.props.location.state.from.search;
            }
        }
    }

    handleError() {
        const {twoFactorError, setSecretError} = this.props;
        if(setSecretError){
            NotificationManager.error(setSecretError,"Set Two Factor Authentication", 3000);
        }
        if(twoFactorError){
            NotificationManager.error(twoFactorError,"Two Factor Authentication Failed", 3000);
        } else {
            NotificationManager.error("","Two Factor Authentication Failed", 3000);
        }
        this.props.initialize({
            authCode: ""
        });
        this.setState({loginBoxClass: "login_error", authModal: false, setModal: false, error:false, loginClicked: false});
    }

    handleSetSecret(){
        //call auth again
        this.setState({setModal: false, authModal: true})
    }

    toggle(){
        this.setState({authModal: !this.state.authModal, loginClicked: false});
    }

    toggle2(){
        this.setState({setModal: !this.state.setModal, loginClicked: false});
    }

    singleSignOn(id){
        window.localStorage.setItem("saml_id", id);
        if (typeof this.props.location.state !== 'undefined') {
            window.localStorage.setItem("continuation_url", "/#" + this.props.location.state.from.pathname + this.props.location.state.from.search);
        }
        this.props.getsso(id)
            .then(() => this.handleSSOSuccess())
            .catch(() => this.handleSSOError());
    }

    handleSSOSuccess() {
        const {sso_url, sso_error_message, sso_error} = this.props;
        if (sso_error_message) {
            NotificationManager.error(sso_error_message,"Saml Login Failed", 5000);
        } else {
            if (sso_url) {
                window.location.href = sso_url;
            } else {
                NotificationManager.error("Contact Administrator","Saml Login Failed", 5000);
            }
        }
    }

    handleSSOError(){
        const {sso_error} = this.props;
        if (sso_error)
            NotificationManager.error("Contact Administrator","Saml Login Failed", 5000);
    }

    async componentDidMount() {
        const { response: settings } = await this.props.getLoginSettings();
        window.localStorage.setItem("login_logo", settings.login_logo);
        window.localStorage.setItem("login_caption", settings.login_caption);
        window.localStorage.setItem("header_logo", settings.header_logo);
        window.localStorage.setItem("login_splash_background", settings.login_splash_background);
        window.localStorage.setItem("splash_background", settings.splash_background);
        window.localStorage.setItem("html_title", settings.html_title);
        window.localStorage.setItem("favicon_logo", settings.favicon_logo);
        window.localStorage.setItem("loading_session_text", settings.loading_session_text);
        window.localStorage.setItem("joining_session_text", settings.joining_session_text);
        window.localStorage.setItem("destroying_session_text", settings.destroying_session_text);
        this.setState({brandingSet: true})

        if (window.localStorage.getItem("user_info") == null) {
            $("body").addClass("login-body");
        }  else {
            $("body").removeClass("login-body");
        }

        if (
            this.props.login_settings.sso_enabled &&
            this.props.saml_configs.length !== 0 &&
            this.props.location.pathname !== "/staticlogin"
        ) {
            const config = _.find(this.props.saml_configs, { auto_login: true });
            config && this.singleSignOn(config.saml_id);
        }
    }

    componentWillUnmount() {
        $("body").removeClass("login-body");
    }

    render() {
        if (this.props.getSsoLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {login_settings, handleSubmit } = this.props;

        let login_splash_background = window.localStorage.getItem('login_splash_background');
        let login_logo = window.localStorage.getItem('login_logo');
        login_logo = login_logo ? login_logo : '/img/logo.png';
        let powered_by = login_logo != "/img/logo.png";

        let login_caption = window.localStorage.getItem('login_caption');
        login_caption = login_caption ? login_caption : 'The Container Streaming Platform';


        let elem = document.getElementById("favicon");
        let favicon_logo = window.localStorage.getItem('favicon_logo');
        if (favicon_logo != undefined){
            elem.href=favicon_logo;
        }

        let html_title = window.localStorage.getItem('html_title');
        if (html_title != undefined){
             document.title=html_title;
        }

        const logins = _.map(this.props.saml_configs, config =>
            <div key={config.saml_id}>
                <div>
                    <Button
                        color="primary"
                        className="px-4 mb-2"
                        onClick={(id) => this.singleSignOn(config.saml_id)}
                        style={{"borderRadius": "3px"}}
                        type="submit">
                        {config.display_name}
                    </Button>
                    <br />
                </div>
            </div>
        );

        return (
            <div > 
                <div className="login_box" style={{backgroundImage: 'url("' + login_splash_background + '")'}}>
                    <div className={"login-flex " + this.state.loginBoxClass}>
                        <CardGroup className="mb-0">
                            <Card className="login-card">
                                <CardBody className="card-body col-md-offset-3 ">
                                    <div className="login-card-top">
                                    <h1 className="login-title"><strong>Login</strong> </h1> 
                                        <Form onSubmit={handleSubmit(this.handleLogin)}>
                                        <InputGroup className="mb-3 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <Field
                                                name="username"
                                                placeholder="Your Email"
                                                component={renderField}
                                                type="text"
                                                validate={required}
                                            />
                                        </InputGroup>
                                        <InputGroup className="mb-4 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="icon-lock"></i>
                                                </span>
                                            </div>
                                            <Field 
                                                name="password"
                                                placeholder="Your Password"
                                                component={renderField}
                                                type="password"
                                                validate={required} 
                                            />
                                        </InputGroup>
                                        <Row>
                                            <Col xs="12">
                                                <div className="text-right">  {this.state.loginClicked ? <Spinner color="primary" className="login-spinner" /> : <Button color="primary" className="login-card-btn"  type="submit">Login</Button>} </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                    </div>
                                        
                                        {login_settings  && login_settings.sso_enabled && logins && logins.length > 0 &&
                                            <div className="login-with">
                                                    <span className="text-muted">Or Login With </span>
                                                    <div>
                                                        {logins}
                                                    </div>
                                            </div>
                                        }
                                
                                </CardBody>
                                {this.props.login_settings && this.props.login_settings.login_assistance &&
                                    <CardFooter className="login-assistance">
                                        <div className="login-assistance-head"><span className="need-help">Need Heelp?</span>
                                        <span className="login-assist-txt"> <i id="login_assistance_tip" className="fa fa-info-circle" />
                                            <a href={this.props.login_settings.login_assistance}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                Login Assistance
                                                <UncontrolledTooltip placement="bottom" target="login_assistance_tip">
                                                    Follow link for login instructions
                                                </UncontrolledTooltip>
                                            </a></span></div> 
                                    </CardFooter>
                                }
                                {this.props.login_settings && this.props.login_settings.notice_message && this.props.login_settings.notice_title &&
                                        <div className="notice-box">
                                                <h4>{this.props.login_settings && this.props.login_settings.notice_title}</h4>
                                                <p>{this.props.login_settings && this.props.login_settings.notice_message}</p>
                                        </div>
                                        } 
                            </Card>
                            <Card className="text-white logo-card   d-md-down-none">
                                <div className="logo-wrapper">
                                    <div className="logo-center">
                                    <img src={login_logo} alt="logo"/>
                                        <CardBody className="text-center">
                                            {powered_by ?
                                            <div className="logo-bottom-txt">
                                                <p>Powered by Kasm Workspaces</p>
                                            </div>
                                            :
                                            ""}
                                            <div className = "logo-bottom-txt">
                                                <h5>{login_caption}</h5>
                                            </div>
                                        </CardBody>
                                    </div>
                                </div>
                            </Card>
                        </CardGroup>

                        <Modal isOpen={this.state.authModal}  toggle={this.toggle} className="user-modal confirm-modal">
                            <Form onSubmit={handleSubmit(this.handleAuth)}>
                                <ModalHeader toggle={this.toggle}>Two Factor Authentication</ModalHeader>
                                <ModalBody className="confirm-modal-body">
                                    Enter Code:
                                    <Field
                                        name="authCode"
                                        type="text"
                                        component={renderField} />
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.toggle} size="sm" color="basic" className="cancel-button">Cancel</Button>
                                    <Button type= "submit" size="sm" color="primary" className="submit-button">Submit</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>

                        <Modal isOpen={this.state.setModal}  toggle={this.toggle2} className="user-modal" backdrop="static">
                            <ModalHeader toggle={this.toggle2}>Authenticator Setup</ModalHeader>
                            { this.props.qrCode ?
                                <div>
                                <ModalBody className="confirm-modal-body">
                                    <p>Two Factor Authentication is required on your account. Please install
                                        <a href="https://support.google.com/accounts/answer/1066447?hl=en&ref_topic=2954345" rel="noopener noreferrer" target="_blank" > Google Authenticator </a>
                                            or similar TOTP based Authenticators and Add this login to your application using the secret provided or by scanning the QR code below.</p>
                                    <div className="text-center">
                                        <h5>Scan this code</h5>
                                        <QRCode
                                            bgColor="#FFFFFF"
                                            fgColor="#000000"
                                            level="Q"
                                            style={{ width: 128 }}
                                            value={this.props.qrCode}
                                        />
                                        <br></br>
                                        <b>Secret: {this.props.generated_secret}</b><br />
                                    </div>
                                </ModalBody>
                                <ModalFooter>
                                    <Button onClick={this.handleSetSecret} size="sm" color="basic" className="submit-button">Continue</Button>
                                </ModalFooter>
                                </div>
                                : ""
                            }
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    loginFunc: Proptypes.func.isRequired,
    fields: Proptypes.array,
    handleSubmit: Proptypes.func,
    isLoggedIn: Proptypes.bool,
    has2fa: Proptypes.bool,
    new_two_factor: Proptypes.bool,
    user_info: Proptypes.object,
    loginError: Proptypes.string,
    history: Proptypes.object,
    initialize: Proptypes.func,
    sso_enabled: Proptypes.string,
};

Login = withRouter(Login);

function mapStateToProps(state) {
    return {
        twoFactorErrorMessage: state.auth.twoFactorErrorMessage || null,
        twoFactorError: state.auth.twoFactorError || null,
        isLoggedIn: state.auth.isLoggedIn,
        has2fa: state.auth.has2fa,
        new_two_factor: state.auth.new_two_factor,
        user_info: state.auth.user_info,
        loginError: state.auth.loginError,
        setSecretErrorMessage: state.auth.setSecretErrorMessage || null,
        setSecretError: state.auth.setSecretError || null,
        qrCode: state.auth.qrCode || null,
        getSecretErrorMessage: state.auth.setSecretErrorMessage || null,
        getSecretError: state.auth.setSecretError || null,
        generated_secret: state.auth.generated_secret || null,
        login_settings: state.auth.login_settings,
        sso_url: state.saml.sso_url,
        saml_configs: _.get(state.auth.login_settings, "saml.saml_configs", []),
        sso_saml_error: state.saml.sso_saml_error,
        sso_error: state.saml.sso_error,
        auto_login_kasm: state.auth.auto_login_kasm,
        getSsoLoading: state.auth.getSsoLoading || false,
    };
}

function mapDispatchToProps(dispatch) {
    return ({
        loginFunc: (login_data) => dispatch(loginFunction(login_data)),
        get_two_factor: (login_data) => dispatch(get_two_factor(login_data)),
        setSecret: (login_data) => dispatch(setSecret(login_data)),
        getSecret: () => dispatch(getSecret()),
        getLoginSettings: () => dispatch(getLoginSettings()),
        getsso: (id) => dispatch(getSignOnURL(id))
    });
}

let LoginWithRouter =  withRouter(Login);

let LoginComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginWithRouter);

export default reduxForm({
    form: "LoginPageForm",
    fields: ["username", "password"]
})(LoginComponent);


// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js